/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListCommentContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
    readonly " $refType": "ReplyListCommentContainer_settings";
};
export type ReplyListCommentContainer_settings$data = ReplyListCommentContainer_settings;
export type ReplyListCommentContainer_settings$key = {
    readonly " $data"?: ReplyListCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '24623d859079f776b46ff224f0226988';
export default node;
